export const customerTasksitesState = {
  name: 'customers.customer.tasksites',
  url: '/tasksites',
  views: {
    'content@customers': 'customerTasksitesComponent',
  },
}



// WEBPACK FOOTER //
// ./app/tasksites/tasksites.states.js